module.exports = __webpack_public_path__ + "static/media/natural-medicine-gc8ec88c61_640.a7643e2e.jpg";